// extracted by mini-css-extract-plugin
module.exports = {"dots":"style_dots__aVDnz","dots-item":"style_dots-item__8aOED","active":"style_active__Na1Lk"};